import React, { useDeferredValue, useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Button, Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import { deleteConfirmation } from "../../utils";
import CustomPagination from "../../components/CustomPagination";
import { StatusComponent } from "../Jobs";
import CreateAssetModal from "./CreateAssetModal";
import ViewAssetModal from "./ViewAssetModal";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import { useGetTractorsQuery, useRemoveTractorMutation } from "../../redux/services/TractorsService";
import { useRemoveJobMutation } from "../../redux/services/JobService";

const Assets = () => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const [tabKey, setTabKey] = useState('tractors');
    const tabs = useDeferredValue(tabKey)

    const [removeRequest] = useRemoveTractorMutation()

    const { data: data2, isFetching, refetch } = useGetTractorsQuery({ id: tabs, pagination: `?page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}` })
    const tractors = data2?.response?.data?.data
    const total = data2?.response?.data?.total;

    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    const handleClose = () => {
        setIsShow(false)
        setIsView(false)
        setIsEdit(false)
    }

    return (
        <>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">

                <PageHeader name="Tractors & Trailers" />
                <div className="main-container container-fluid">
                    <div className="card">
                        <div className="card-header d-flex w-100 justify-content-between align-items-center">
                            <Nav variant="pills" className="gap-2">
                                <Nav.Item>
                                    <Nav.Link eventKey="first" onClick={() => setTabKey("tractors")}>
                                        Tractors
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second" onClick={() => setTabKey("trailer")}>
                                        Trailers
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <div class="w-auto">
                                <Button variant="primary" onClick={handleAdd}>
                                    + Create
                                </Button>
                            </div>
                        </div>
                        <div className="card-body ">
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <CustomPagination
                                        isFetching={isFetching}
                                        data={tractors}
                                        total={total}
                                        onChangePage={handlePageChange} // Handle page change
                                        onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                        paginationDefaultPage={currentPage} // Set the current page
                                        columns={[
                                            { name: 'ID', selector: row => row?.id, sortable: true, width: '80px' },
                                            { name: 'Make', selector: row => row.make, sortable: true },
                                            { name: 'Model', selector: row => row.model, sortable: true },
                                            // { name: 'Selected Date & Time', selector: row => row.selectedDateTime, sortable: true },
                                            { name: 'Year', selector: row => `$${row.year}`, sortable: true },
                                            { name: 'VIN', selector: row => row?.vin, sortable: true, width: '200px' },
                                            {
                                                name: 'Dot Expiry', selector:
                                                    row => (
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <span className='px-2 py-1 bg-danger text-white rounded-2'>{row?.dot_inspection_expiry}</span>
                                                            <span type="button" title='View Doc' className="px-2 py-1 bg-primary text-white rounded-pill">
                                                                👁
                                                            </span>
                                                        </div>

                                                    ),
                                                sortable: true,
                                                width: '170px',
                                            },
                                            {
                                                name: 'Cab Card Expiry',
                                                selector: row => row?.cab_card_expiry ? <span className='d-flex px-2 py-1 bg-warning text-white rounded-2'>{row?.cab_card_expiry}</span> : '-',
                                                sortable: true,
                                                width: '130px',
                                            },
                                            // { name: 'Status', selector: row => <StatusComponent status={row?.status} />, sortable: false, width: '120px' }, // Assigned, Pending, Active, Completed,
                                            { name: 'Created At', selector: row => (row?.created_at), sortable: true, width: '120px' },
                                            {
                                                name: 'Actions',
                                                cell: (row) => {
                                                    return (
                                                        <div className="hstack gap-1 fs-1">
                                                            <button
                                                                aria-label="view"
                                                                onClick={() => handleView(row)}
                                                                className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-eye-fill" />
                                                            </button>
                                                            <button
                                                                aria-label="edit"
                                                                // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                                                                onClick={() => handleEdit(row)}
                                                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-edit-line" />
                                                            </button>
                                                            <a
                                                                aria-label="delete"
                                                                onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-delete-bin-7-line" />
                                                            </a>
                                                        </div>
                                                    )
                                                },
                                                ignoreRowClick: true,
                                                allowOverflow: true,
                                                button: true,
                                                width: '220px'
                                            },
                                        ]}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <CustomPagination
                                        isFetching={isFetching}
                                        data={tractors}
                                        total={total}
                                        onChangePage={handlePageChange} // Handle page change
                                        onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                        paginationDefaultPage={currentPage} // Set the current page
                                        columns={[
                                            { name: 'ID', selector: row => row?.id, sortable: true, width: '80px' },
                                            { name: 'Make', selector: row => row.make, sortable: true },
                                            { name: 'Model', selector: row => row.model, sortable: true },
                                            // { name: 'Selected Date & Time', selector: row => row.selectedDateTime, sortable: true },
                                            { name: 'Year', selector: row => `$${row.year}`, sortable: true },
                                            { name: 'VIN', selector: row => row?.vin, sortable: true },
                                            {
                                                name: 'Dot Expiry', selector:
                                                    row => (
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <span className='px-2 py-1 bg-danger text-white rounded-2'>{row?.dot_inspection_expiry}</span>
                                                            <span type="button" title='View Doc' className="px-2 py-1 bg-primary text-white rounded-pill">
                                                                👁
                                                            </span>
                                                        </div>

                                                    ),
                                                sortable: true,
                                                width: '170px',
                                            },
                                            { name: 'Status', selector: row => <StatusComponent status={row?.status} />, sortable: false }, // Assigned, Pending, Active, Completed,
                                            { name: 'Created At', selector: row => (row?.created_at), sortable: true },
                                            {
                                                name: 'Actions',
                                                cell: (row) => {
                                                    return (
                                                        <div className="hstack gap-1 fs-1">
                                                            <button
                                                                aria-label="view"
                                                                onClick={() => handleView(row)}
                                                                className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-eye-fill" />
                                                            </button>
                                                            <button
                                                                aria-label="edit"
                                                                // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                                                                onClick={() => handleEdit(row)}
                                                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-edit-line" />
                                                            </button>
                                                            <a
                                                                aria-label="delete"
                                                                onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-delete-bin-7-line" />
                                                            </a>
                                                        </div>
                                                    )
                                                },
                                                ignoreRowClick: true,
                                                allowOverflow: true,
                                                button: true,
                                                width: '220px'
                                            },
                                        ]}
                                    />
                                </Tab.Pane>
                            </Tab.Content>

                        </div>
                    </div>
                </div>
            </Tab.Container>

            {isShow && (
                <CreateAssetModal
                    handleClose={handleClose}
                    isEdit={isEdit}
                />
            )}

            {isView && (
                <ViewAssetModal
                    handleClose={handleClose}
                    asset={isEdit}
                />
            )}


        </>
    );
};

export default Assets;